const state = {
    wireInquireResultFields: [
        {
            key: "item_index",
            label: "項次",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "code",
            label: "線材品號",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "furnace_code",
            label: "爐號",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "start_weight",
            label: "起(kg)",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "end_weight",
            label: "迄(kg)",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "usage",
            label: "使用量(kg)",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "scales_data",
            label: "秤架資料",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
    ],
    wireInquireResultItem: [],
    wireInquireWorkCode: ""
}
const getters = {
    get_wireInquireResultFields: state => {
        return state.wireInquireResultFields
    },
    get_wireInquireResultItem: state => {
        return state.wireInquireResultItem
    },    
    get_wireInquireWorkCode: state => {
        return state.wireInquireWorkCode
    },
}
const actions = {
    set_wireInquireResultFields(context, array) {
        context.commit('SET_WIREINQUIRERESULTFIELDS', array);
    },
    set_wireInquireResultItem(context, array) {
        context.commit('SET_WIREINQUIRERESULTITEM', array);
    },
    clear_wireInquireResultItem(context) {
        context.commit('CLEAR_WIREINQUIRERESULTITEM');
    },
    set_wireInquireWorkCode(context, string) {
        context.commit('SET_WIREINQUIREWORKCODE', string);
    },
    clear_wireInquireWorkCode(context) {
        context.commit('CLEAR_WIREINQUIREWORKCODE');
    },
}
const mutations = {
    SET_WIREINQUIRERESULTFIELDS(state, array) {
        state.wireInquireResultFields = array;
    },
    SET_WIREINQUIRERESULTITEM(state, array) {
        state.wireInquireResultItem = array;
    },
    CLEAR_WIREINQUIRERESULTITEM(state) {
        state.wireInquireResultItem = [];
    },
    SET_WIREINQUIREWORKCODE(state, string) {
        state.wireInquireWorkCode = string;
    },
    CLEAR_WIREINQUIREWORKCODE(state) {
        state.wireInquireWorkCode = "";
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wireInquireResult.js